import React, { useEffect, useState, useContext } from "react";
import Slider from "react-slick";
import { apiGet, apiPost } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import AuthContext from "../../context/AuthContext";

const MainBanner = () => {
  const { downloadBar } = useContext(AuthContext);
  const banners = [
    "/assets/images/banner/banner1.jpg",
    "/assets/images/banner/banner2.jpg",
    "/assets/images/banner/banner3.jpg",
    // "/assets/images/banner/banner4.webp",
  ];

  var settings = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 3000,
    arrows: true,
    // className: "center",
    centerMode: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          centerMode: false,
        },
      },
    ],
    appendDots: (dots) => <ul>{dots}</ul>,
    customPaging: (i) => (
      <div className="ft-slick__dots--custom">
        <div className="loading" />
      </div>
    ),
  };
  const [data, setData] = useState([]);
  const getData = async () => {
    const { status, data } = await apiPost(apiPath.getBanner, {
      type: "home_top",
    });
    if (status == 200) {
      if (data?.success) {
        setData(data?.results?.banners);
      }
    }
  };
  useEffect(() => {
    getData();
  }, []);
  return (
    <div className={`main-banner-block ${downloadBar ? "main-banner" : "main-banner banner-bar-height"}`}>
      {" "}
      <Slider {...settings}>
        {/* {banners.map((banner, index) => (
          <div key={index} className="slider-items-banner">
            <figure className="mb-0">
              <img
                style={{ width: "100%", height: "auto" }}
                src={banner}
                alt={`banner-${index + 1}`}
                fetchpriority="high"
              />
            </figure>
          </div>
        ))} */}
        {data?.length > 0 &&
          data?.map((item) => {
            return (
              <div className="slider-items-banner">
                <figure className="mb-0">
                  <img
                    style={{
                      width: "250px",
                      height: "113px",
                    }}
                    src={import.meta.env.VITE_API_BASE_URL + item?.banner_path}
                    alt=""
                  />
                </figure>
              </div>
            );
          })}
      </Slider>
    </div>
  );
};

export default MainBanner;
